<template>
  <container-tasks
    :container="{ id: item.id, abbrev_type: item.abbrev_type }"
    :tasks="item.tasks"
  />
</template>

<script>
export default {
  name: "order-status-tasks",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
